import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Stack,
} from "react-bootstrap";
import Confirm from "../Confirm";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { ROUTES } from "../../constants/webRouting";
import solisPowerApi from "../../api/solisPowerApi";
import PERMISSIONS from "../../constants/permissions";
import { getUserDetails } from "../../utils/helper";
import { formatDateForView } from "../../utils/helper";

const CommissionView = (props) => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  const [commission, setCommission] = useState(
    location.state ? location.state : {}
  );
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    init();
  }, []);

  async function init() {
    const commissionId = commission.id
      ? commission.id
      : location?.pathname?.split("/")?.at(2);

    if (commissionId) {
      let result = await solisPowerApi.fetchCommissionById(commissionId);
      if (result) {
        setCommission(result);
      }
    }
  }

  const deleteCommission = async () => {
    const result = await solisPowerApi.deleteCommission(commission.id);
    if (result?.success) {
      navigate(ROUTES.COMMISSION.LIST);
    }
  };

  const editCommission = () => {
    navigate(`${ROUTES.COMMISSION.EDIT.replace(":id", commission.id)}`, {
      state: commission,
    });
  };

  return (
    <>
      {commission && (
        <Container className="pb-5">
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteCommission={deleteCommission}
              title="Confirm delete?"
              message="You are going to delete the commission record. Are you sure?"
              table="commission"
            />
          )}
          <Row className="">
            <Col md={12} className="">
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  onClick={() => navigate(ROUTES.COMMISSION.LIST)}
                >
                  Commissions
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col md={12}>
              <Row className="">
                <Col lg={12}>
                  <Card className="shadow">
                    <CardHeader className="bg-custom text-white">
                      <Row className="w-100">
                        <Col lg={6} className="">
                          <div className="d-flex align-items-center h-100 gap-3">
                            <h5 className="m-0">Commission</h5>
                            <h5 className="m-0">{`${commission.firstname || ""}`}</h5>
                          </div>
                        </Col>
                        <Col lg={6} className="p-0">
                          <Stack direction="horizontal" className="float-end" gap={3}>
                            {[PERMISSIONS.MODIFY_ALL, PERMISSIONS.MODIFY_MAKE].some(
                              (permission) => {
                                return userInfo?.permissions
                                  .map((p) => p.name)
                                  .includes(permission);
                              }
                            ) && (
                                <Button
                                  size="sm"
                                  className="btn-edit"
                                  onClick={() => editCommission(true)}
                                >
                                  <i className="fa-regular fa-pen-to-square"></i>
                                </Button>
                              )}

                            {[PERMISSIONS.DELETE_ALL, PERMISSIONS.DELETE_MAKE].some(
                              (permission) => {
                                return userInfo?.permissions
                                  .map((p) => p.name)
                                  .includes(permission);
                              }
                            ) && (
                                <Button
                                  size="sm"
                                  className="btn-delete"
                                  onClick={() => setModalShow(true)}
                                >
                                  <i className="fa fa-trash-o"></i>
                                </Button>
                              )}
                          </Stack>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody className="">
                      <Row className="view-form">
                        <Col lg={6}>
                          <label>Commission Agent Name</label>
                          <span>{commission.contact_name || "-"}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Amount</label>
                          <span>
                            {commission.amount !== null &&
                              commission.amount !== undefined
                              ? `₹${parseFloat(commission.amount).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}`
                              : "-"}
                          </span>
                        </Col>
                        <Col lg={6}>
                          <label>Lead</label>
                          <span>{commission.lead_name || "-"}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Project</label>
                          <span>{commission.project_name || "-"}</span>
                        </Col>

                        {/* <Col lg={6}>
                          <label>Lead</label>
                          <span>
                            {commission.lead_id ? (
                              <Link
                                to={`${ROUTES.LEAD.VIEW.replace(
                                  ":id",
                                  commission.lead_id
                                )}`}
                                state={commission}
                              >
                                {commission.lead_name ||
                                  commission.lead_no ||
                                  "View Lead"}
                              </Link>
                            ) : (
                              "-"
                            )}
                          </span>
                        </Col>
                        <Col lg={6}>
                          <label>Contact</label>
                          <span>
                            {commission.contact_id ? (
                              <Link
                                to={`${ROUTES.CONTACT.VIEW.replace(
                                  ":id",
                                  commission.contact_id
                                )}`}
                                state={commission}
                              >
                                {commission.contact_name || "View Contact"}
                              </Link>
                            ) : (
                              "-"
                            )}
                          </span>
                        </Col> */}
                        <Col lg={6}>
                          <label>Created By</label>
                          <span>
                            {commission.createdbyname || commission.createdbyname || "-"}
                          </span>
                        </Col>
                        <Col lg={6}>
                          <label>Last Modified By</label>
                          <span>
                            {commission.lastmodifiedbyname ||
                              commission.lastmodifiedbyname ||
                              "-"}
                          </span>
                        </Col>
                        <Col lg={6}>
                          <label>Created Date</label>
                          <span>
                            {commission.createddate
                              ? formatDateForView(commission.createddate)
                              : "-"}
                          </span>
                        </Col>
                        <Col lg={6}>
                          <label>Last Modified Date</label>
                          <span>
                            {commission.lastmodifieddate
                              ? formatDateForView(commission.lastmodifieddate)
                              : "-"}
                          </span>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

export default CommissionView;

